module cr.entity {
    class entityModuleHomeController
    {
        static $inject = ['$scope', 'currentUser', 'userPermission', 'entityModule', 'entityService', '$stateParams','$state','treeManager'];

        getNodesScope = (path?:string):any => {
            return angular.element(document.getElementById("tree-root")).scope();
        }

        constructor(private $scope, currentUser:cr.account.ICurrentUser, userPermission:cr.account.IUserPermission
            , private entityModule:EntityModule, private entityService:IEntityService, private $stateParams:any
            , private $state:any
            , private treeManager:ITreeManager) {

            $scope.context = 'Entity';
            $scope.userPermission = userPermission;

            for (var entityId in entityModule.Definitions)
            {
                console.log("entity: "+entityId);
                var entity:EntityDefinitionView=entityModule.Definitions[entityId];
                if (entity.Root) {
                    treeManager.AddNode(new EntityListTreeNode(this.entityService,entity,entityModule));
                }
            }
          /*  for (var rootEntity in this.rootEntities) {
                treeManager.AddNode(new EntityListTreeNode(this.rootEntities[rootEntity],$stateParams["moduleName"]));
            }*/

            $scope.tree = treeManager;

            $scope.back = ()=> {
                $state.go("entity.module");
            }

            /*$scope.showModuleContent = ()=> {
                console.log("ca va être cool");
                $state.go("entity.module.test");
            };
            $scope.remove = scope => {
                scope.remove();
            }
            $scope.toggle = scope => {
                console.log("toggle");
                if (!angular.isDefined(scope)) return;
                console.log("toggle: " + angular.toJson(scope));
                scope.toggle();
            }
            $scope.moveLastToTheBegginig = ()=> {
                var a = $scope.data.pop();
                $scope.data.splice(0, 0, a);
            };
            $scope.newSubItem = (scope) => {
                var nodeData = scope.$modelValue;
                nodeData.nodes.push({
                    id: nodeData.id * 10 + nodeData.nodes.length,
                    title: nodeData.title + '.' + (nodeData.nodes.length + 1),
                    nodes: []
                });
            };
            $scope.collapseAll = () => {
                var scope = this.getNodesScope();
                scope.collapseAll();
            };
            $scope.expandAll = () => {
                var scope = this.getNodesScope();
                scope.expandAll();
            };
            $scope.SelectEntity = (entity:any)=> {
                console.log("We select entity: " + entity.Id + " / " + entity[0]);
            }*/
        }
    }

    // Module registrations.
    entityModule.controller('entityModuleHomeController', entityModuleHomeController);

}
